import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';


export default function Login(){

    const[email,setEmail] = useState('');
    const[pw,setPw] = useState('');

    const [showMessage, setShowMessage] = useState(false);

    const[emailValid, setEmailValid] = useState(false);
    const[pwValid, setPwValid] = useState(false);
    const[notAllow, setNotAllow] = useState(true);

    const [showPassword, setShowPassword] = useState(false); // 비밀번호 보이기 토글 상태

    const [cookies, setCookie] = useCookies(['uuid']);

    useEffect(() => {
      // 여기에 통신 요청이 완료되면 알림 메시지를 자동으로 사라지게 하는 로직을 추가하세요.
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 5000); // 5초 후에 알림 메시지를 숨김
      return () => clearTimeout(timer); // 컴포넌트가 언마운트되면 타이머 해제
    }, [showMessage]); 

    
    const handleEmail = (e) => {
      const newEmail = e.target.value.trim();
      setEmail(newEmail);
      const regex = 
      /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
      if (regex.test(newEmail)) {
          setEmailValid(true);
        } 
      else {
          setEmailValid(false);
        }
      };
        
    const handlePw = (e) => {
      const newPw = e.target.value.trim();
      setPw(newPw);
        const regex =
          /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
        if (regex.test(newPw)) {
          setPwValid(true);
        } 
      else {
          setPwValid(false);
        }
      };
    
    useEffect(() => {
        if(emailValid && pwValid) {
          setNotAllow(false);
          return;
        }
        setNotAllow(true);
      }, [emailValid, pwValid]);

    const onClickConfirmButton = () => {
      const loginData = {
        email: email,
        password: pw
      };
      
      setShowMessage(true);

      // 서버에 POST 요청을 보냄
      fetch('/login/check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('서버 응답 실패');
        }
        return response.text();
      })
      .then(data => {
          const mg_data = JSON.parse(data)
          setShowMessage(false);
          if(mg_data.message === undefined){
            let redirectUrl
            let newUUID
            let direct_setpage
            if (mg_data[0].uuid === undefined){
              newUUID = mg_data.uuid;
            } else {
              newUUID = mg_data[0].uuid;
            }
            setCookie('uuid', newUUID, { path: '/' });

            if (mg_data[0].direct_setpage === undefined){
              direct_setpage = mg_data.direct_setpage;
            } else {
              direct_setpage = mg_data[0].direct_setpage;
            }
            alert('로그인에 성공했습니다.');

            redirectUrl = `/SelectPage`;
            window.location.href = redirectUrl;

          } else {
            alert(mg_data.message)
          }
       })
      .catch(error => {
        console.error('오류 발생:', error);
        alert(error);
      }); 
    }

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        onClickConfirmButton();
      }
    };

    return(
      <div className="auth-page auth-page--login">
        <span className="auth-page__overlay" />
        <div className="auth-page__content">
          <section className="auth-hero">
            <p className="auth-badge">Bitget Access</p>
            <h1>
              전략, 주문, 알림을<br />
              하나의 계정으로 이어주세요.
            </h1>
            <p className="auth-hero__subtitle">
              Bitgenstone 자동매매 허브와 연동하면 Bitget 전용 전략과 리스크 컨트롤을 어디서든 이어갈 수 있습니다.
            </p>
            <ul className="auth-highlight-list">
              <li>24가지 프리셋 전략 즉시 불러오기</li>
              <li>모바일에서도 동일한 제어 환경</li>
              <li>긴급 정지 · 헷지 버튼 실시간 반영</li>
            </ul>
          </section>

          <section className="auth-card">
            <div className="auth-card__header">
              <h2>로그인</h2>
              <p>등록된 이메일과 비밀번호로 Bitgenstone 계정에 접속하세요.</p>
            </div>

            <div className="auth-form">
              <div className="auth-field">
                <label>이메일 주소</label>
                <div className="auth-input">
                  <input
                    type='text'
                    placeholder="test@gmail.com"
                    value={email}
                    onChange={handleEmail}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                {!emailValid && email.length > 0 && (
                  <p className="auth-error">올바른 이메일을 입력해주세요.</p>
                )}
              </div>

              <div className="auth-field">
                <label>비밀번호</label>
                <div className="auth-input auth-input--with-action">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="영문(대문자 포함), 숫자, 특수문자 포함 8자 이상"
                    value={pw}
                    onChange={handlePw}
                    onKeyDown={handleKeyDown}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="auth-toggle"
                  >
                    {showPassword ? "숨기기" : "보기"}
                  </button>
                </div>
                {!pwValid && pw.length > 0 && (
                  <p className="auth-error">영문, 숫자, 특수문자 포함 8자 이상 입력해주세요.</p>
                )}
              </div>

              {showMessage && (
                <div className="auth-inline-message">
                  거래소와 통신 중입니다. 잠시만 기다리세요!
                </div>
              )}

              <button
                onClick={onClickConfirmButton}
                disabled={notAllow}
                className="auth-submit"
              >
                로그인
              </button>

              <div className="auth-links">
                <a href="/SelectBitget">비트겟 전략 메인 페이지</a>
                <span>·</span>
                <a href="/SignupAts">회원가입</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
}